// Helpers for the Capacitor shell (iOS/Android app wrapping this site). Everything is progressive:
// in a normal browser these all return false/null and callers fall back to web behaviour.
export const isNative = () => !!(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform())
export const platform = () => (isNative() ? window.Capacitor.getPlatform() : "web")

// Plugins are injected by the native bridge, even on a remote (server.url) page.
export const plugin = (name) => (isNative() && window.Capacitor.Plugins ? window.Capacitor.Plugins[name] : null)

// Marks <html class="native"> so CSS can hide marketing bits even if the user agent marker is missing.
export function markNative() {
  if (!isNative()) return
  document.documentElement.classList.add("native", `native-${platform()}`)

  // Universal Links / App Links / quick actions arrive as appUrlOpen: open that path inside the shell.
  plugin("App")?.addListener("appUrlOpen", ({ url }) => {
    const target = new URL(url)
    if (target.host === window.location.host) window.Turbo ? window.Turbo.visit(target.pathname + target.search) : (window.location = url)
  })

  // Tapped push notification: FCM data.path
  plugin("FirebaseMessaging")?.addListener("notificationActionPerformed", ({ notification }) => {
    const path = notification?.data?.path
    if (typeof path === "string" && path.startsWith("/")) window.Turbo ? window.Turbo.visit(path) : (window.location = path)
  })
}
